import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import { useEffect } from "react";
import cn from "classnames";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";
import useDiplomaRequest from "@/utils/hooks/useDiplomaRequest.ts";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import { useTranslation } from "react-i18next";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

const DiplomaRequestNotification = () => {
  const { date, hour } = useDiplomaRequest();
  const newDate = dayjs(date);

  const { setGlobalState } = useGlobals();

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-light");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!date) {
      navigate(routes.diploma_request);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <DashboardContentLayout className="h-full">
      <div className="flex flex-col h-full">
        <header className={"flex flex-col items-center mt-2"}>
          <p
            className={"text-brand-secondary text-xl font-semibold text-start"}
          >
            {t("diploma_request.modal.already_scheduled")}
          </p>
        </header>

        <div className="flex flex-col items-center justify-between mt-4 h-full w-full">
          <CalendarIllustration
            day={newDate.format("DD")}
            month={newDate.format("MMM")}
            header={newDate.format("ddd")}
            className={cn(
              "w-2/4 border-solid border-2 rounded-md",
              "block text-center translate-x-1",
            )}
          />
          <div className="flex flex-col gap-8 h-fit my-auto items-center">
            <div className={"mt-4 text-center"}>
              <h5 className={"text-brand text-15px"}>
                {t("diploma_request.modal.time")}
              </h5>
              <p className={"text-brand-secondary font-semibold text-2xl"}>
                {hour}
              </p>
            </div>

            <div className={"mt-4 text-center"}>
              <h5 className={"text-brand text-15px"}>
                {t("diploma_request.modal.duration")}
              </h5>
              <p className={"text-brand-secondary font-semibold text-2xl"}>
                {20}&nbsp; {t("diploma_request.modal.minutes")}
              </p>
            </div>
          </div>
        </div>
        <div className={"flex flex-col flex-grow"}>
          <p className="text-brand text-center mt-10">
            {t("diploma_request.modal.reschedule_message")}
          </p>
        </div>
      </div>
    </DashboardContentLayout>
  );
};

export default DiplomaRequestNotification;
